document.addEventListener('DOMContentLoaded', function () {


  // Clear filter values when visiting Home page
  if (document.querySelector('.temp_index')) {
    if (localStorage.getItem('filter_product')) {
      localStorage.removeItem('filter_product');
    }
    if (localStorage.getItem('filter_type')) {
      localStorage.removeItem('filter_type');
    }
    if (localStorage.getItem('parent_url')) {
      localStorage.removeItem('parent_url');
    }
  }

  if(!window.location.href.includes('/collections/')) {
    if (localStorage.getItem('parent_url')) {
      localStorage.removeItem('parent_url');
    }
  }



  //Product grid quntity change
  const product_grid = document.querySelector('#product-grid');
  if (product_grid) {
    const product_boxes = product_grid.querySelectorAll(
      '.product-card-wrapper .product_card_quick_add'
    );

    product_boxes.forEach(box => {
      const qtyInput = box.querySelector('.card__quantity');
      const customInput = box.querySelector('.custom-quantity-input');

      if (!qtyInput || !customInput) return;

      qtyInput.addEventListener('input', function () {
        let qty = this.value;
        customInput.value = qty;
      });

      qtyInput.addEventListener('change', function () {
        let qty = this.value;
        customInput.value = qty;
      });
    });
  }

window.tabsOnProduct = function () {
  // product page descrition and product details tab show/hide
  const tabs = document.querySelectorAll(".product_desc_title");
  const contents = document.querySelectorAll(".product_info_tabs");

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.style.display = "none");

      this.classList.add("active");
      const id = this.getAttribute("data-id");
      document.querySelector(`.product_info_tabs[data-value="${id}"]`).style.display = "block";
    });
  });

  // Product page Show More / Less
  document.querySelectorAll(".toggle-description").forEach(btn => {
    btn.addEventListener("click", function () {
      const content = this.previousElementSibling;
      content.classList.toggle("collapsed");

      this.textContent = content.classList.contains("collapsed")
        ? this.dataset.more || "Show more"
        : this.dataset.less || "Show less";
    });
  });
};

// Call function
window.tabsOnProduct();


  //Home Page Slider Section JS


  document.querySelectorAll('.image-text-overlay-slider').forEach(section => {

    const slider = section.querySelector('.slider');
    if (!slider) return;

    if (slider.dataset.init) return;
    slider.dataset.init = true;

    const prev = section.querySelector('.prev-btn');
    const next = section.querySelector('.next-btn');
    const dots = section.querySelectorAll('.slider-counter__link--dots');

    let slides = slider.querySelectorAll('.slider__slide');
    const total = slides.length;

    if (total < 2) return;

    const autoplay = section.dataset.autoplay === 'true';
    const speed = Number(section.dataset.autoplaySpeed) || 5000;

    // clone slides
    const h1 = slides[0].querySelector('h1');
    if (h1) {
      h1.outerHTML = h1.outerHTML.replace('<h1', '<h2').replace('</h1>', '</h2>');
    }
    const firstClone = slides[0].cloneNode(true);
   
    const lastClone = slides[total - 1].cloneNode(true);
    const h2 = lastClone.querySelector('h2');
    if (h2) {
      h2.outerHTML = h2.outerHTML.replace('<h2', '<h1').replace('</h2>', '</h1>');
    }

    slider.append(firstClone);
    slider.prepend(lastClone);

    slides = slider.querySelectorAll('.slider__slide');

    let index = 1;
    let timer;
    let scrollTimeout;

    const slideWidth = () => slides[0].offsetWidth;

    slider.scrollLeft = slideWidth();

    const setDot = i => {
      dots.forEach(d => d.classList.remove('slider-counter__link--active'));
      dots[(i - 1 + total) % total]?.classList.add('slider-counter__link--active');
    };

    const move = (i, smooth = true) => {
    if (i > total + 1) i = total + 1;
    if (i < 0) i = 0;
    
      index = i;

      slider.scrollTo({
        left: slideWidth() * index,
        behavior: smooth ? 'smooth' : 'auto'
      });

      setDot(index);
    };

    const nextSlide = () => move(index + 1);
    const prevSlide = () => move(index - 1);

    next?.addEventListener('click', nextSlide);
    prev?.addEventListener('click', prevSlide);

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => move(i + 1));
    });

    slider.addEventListener('scroll', () => {


      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {

        const i = Math.floor(slider.scrollLeft / slideWidth());
        
        if (i === slides.length - 1) {
          index = 1;
          slider.scrollTo({
            left: slideWidth(),
            behavior: 'auto'
          });
        }

        else if (i === 0) {
          index = slides.length - 2;
          slider.scrollTo({
            left: slideWidth() * index,
            behavior: 'auto'
          });
        }

        else {
          index = i;
        }

        setDot(index);

      }, 150);

    });

    const start = () => {
      if (!autoplay) return;
      timer = setInterval(nextSlide, speed);
    };

    const stop = () =>{ 
      clearInterval(timer)
    };

    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    section.addEventListener('touchstart', stop, { passive: true });

    window.addEventListener('resize', () => {
      slider.scrollLeft = slideWidth() * index;
    });

    start();

  });

  //collection page quntity input js
  document.querySelectorAll('.quantity__input[type=number]').forEach((input) => {
    input.addEventListener('input', () => {
      let value = parseInt(input.value, 10);
      if (!isNaN(value) && value < 1) {
        input.value = 1;
      }
    });

    input.addEventListener('change', () => {
      let value = parseInt(input.value, 10);
      if (isNaN(value) || value < 1) {
        input.value = 1;
      }
    });
  });


  //Home Page Testimonials Slider js
  document.querySelectorAll('.slider-viewport').forEach(viewport => {

    const track = viewport.querySelector('.slider-track-main');
    const slides = track?.querySelectorAll('.slider-slides');
    const dots = viewport.querySelectorAll('.slider-dot');

    if (!track || slides.length === 0) return;

    const slideWidth = slides[0].offsetWidth;

    function updateActiveDot() {
      const scrollLeft = track.scrollLeft;
      const index = Math.round(scrollLeft / slideWidth);

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index, 10);
        track.scrollTo({
          left: index * slideWidth,
          behavior: 'smooth'
        });
      });
    });

    track.addEventListener('scroll', () => {
      updateActiveDot();
    });

    updateActiveDot();

    let isScrolling = false;
    track.addEventListener('touchstart', () => {
      isScrolling = true;
    }, { passive: true });

    track.addEventListener('touchend', () => {
      setTimeout(() => {
        isScrolling = false;
        updateActiveDot();
      }, 120);
    }, { passive: true });


    window.addEventListener('resize', () => {
      const newSlideWidth = slides[0].offsetWidth;
      updateActiveDot();
    });

  });



  // Select all headings inside featured collection
  if (window.innerWidth >= 800) {
    const headings = document.querySelectorAll('.temp_collection .featured_collection ul li .card__heading');
    if (headings) {
      let maxHeight = 0;

      // Loop through headings to find the tallest
      headings.forEach(heading => {
        const height = heading.offsetHeight; // Get current height
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      // Set all headings to the tallest height
      headings.forEach(heading => {
        heading.style.height = maxHeight + 'px';
      });
    }
  }


  //menu active localstorage
    var menuItems = document.querySelectorAll('.header__submenu');
    if(menuItems){
    if (document.querySelector('.temp_index,.temp_search,.temp_cart')){
       localStorage.removeItem('menu_link', true);
    }
    menuItems.forEach(function(item) {
      item.addEventListener('click', function() {
          localStorage.setItem('menu_link', true);
      });
    });
  }

  var related_products = document.querySelector('.related-products');
      if (related_products){
        related_products.addEventListener('click', function() {
        localStorage.removeItem('menu_link', true);
      });
  }
  
    document.querySelectorAll("[name='note']").forEach(textarea => {
      textarea.value = "";
    });

    document.querySelector('.newsletter-form').addEventListener('submit', function () {
      const button = this.querySelector('.footer_newletter_btn');

      button.disabled = true;
      button.classList.add('loading');
    });


    // // product card subscription date functionality
    // document.querySelectorAll('.product_main_form .subscription_calendar_dates_field').forEach(input => {
    //   input.addEventListener('change', function () {
    //     let time = this.value;
    //     input.closest('.product_main_form').querySelector('product-form').dataset.value = time;
    //   });
    // });
    // var productInfoEl = document.querySelector('product-info');
    // if (productInfoEl) {
    //   productInfoEl.querySelectorAll('quantity-input').forEach(function(qtyInput) {
    //     qtyInput.addEventListener('change', function(e) {
    //       e.stopPropagation();
    //     });
    //   });
    // }
  });



window.initializeProductEvents = function () {

  // Product card subscription date functionality
  document.querySelectorAll('.product_main_form .subscription_calendar_dates_field').forEach((input) => {
    input.addEventListener('change', function () {
      const time = this.value;

      const productForm = input.closest('.product_main_form')?.querySelector('product-form');
      if (productForm) {
        productForm.dataset.value = time;
      }
    });
  });

  // Prevent quantity-input change event propagation
  const productInfoEl = document.querySelector('product-info');

  if (productInfoEl) {
    productInfoEl.querySelectorAll('quantity-input').forEach((qtyInput) => {
      qtyInput.addEventListener('change', function (e) {
        e.stopPropagation();
      });
    });
  }

};

window.initializeProductEvents();